import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = {
	sort: 'createDate,desc',
	tasks: [],
	selected: [],
	lastSubmittedFormData: {},
};

const reducerMap = {
	[types.CHANGE_SORT]: (state, { payload }) => {
		return {
			...state,
			sort: payload.sort,
		};
	},
	[types.SET_TASKS]: (state, { payload }) => {
		return {
			...state,
			tasks: payload.tasks,
			selected: [],
		};
	},
	[types.APPEND_TASKS]: (state, { payload }) => {
		return {
			...state,
			tasks: [...state.tasks, ...payload.tasks],
		};
	},
	[types.SAVE_LAST_SUBMITTED_FORMDATA]: (state, { payload }) => {
		return {
			...state,
			lastSubmittedFormData: payload?.formData,
		};
	},
	[types.SELECT]: (state, { payload }) => {
		return {
			...state,
			selected: [...state.selected, payload.taskId],
		};
	},
	[types.UNSELECT]: (state, { payload }) => {
		return {
			...state,
			selected: state.selected.filter((taskId) => taskId !== payload.taskId),
		};
	},
	[types.RESET]: () => initialState,
};

export default handleActions(reducerMap, initialState);
